import React, { ReactNode } from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: ReactNode;
  intro?: ReactNode;
  dark?: boolean;
  align?: 'center' | 'left';
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  dark = false,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  return <div className={`${align === 'center' ? 'mx-auto max-w-[820px] text-center' : 'max-w-[620px]'} mb-9 sm:mb-12 ${className}`} data-id="element-155" data-mp="3k18ag6cofsjo">
      <Eyebrow dark={dark} data-id="element-156" data-mp="bmgf4ot2sjy2">{eyebrow}</Eyebrow>
      <SectionTitle dark={dark} data-id="element-157" data-mp="gjzr1i2awkmu">{title}</SectionTitle>
      {intro && <p className={`mt-4 text-[15px] sm:mt-5 sm:text-lg ${dark ? 'text-white/75' : 'text-muted'}`} data-id="element-158" data-mp="glawdmbea0g2">{intro}</p>}
    </div>;
}
export function Eyebrow({
  children,
  dark = false
}: {
  children: ReactNode;
  dark?: boolean;
}) {
  return <p className={`mb-3 text-[11px] font-bold uppercase tracking-[0.2em] sm:text-xs ${dark ? 'text-teal-light' : 'text-teal'}`} data-id="element-159" data-mp="uipsf9w5l6h0">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  dark = false
}: {
  children: ReactNode;
  dark?: boolean;
}) {
  return <h2 className={`font-condensed text-[36px] font-extrabold uppercase leading-[0.95] tracking-[-0.01em] sm:text-[48px] lg:text-[56px] ${dark ? 'text-white' : 'text-navy'}`} data-id="element-160" data-mp="1oaw4f2uzvopa">
      {children}
    </h2>;
}
export function Highlight({
  children,
  dark = false
}: {
  children: ReactNode;
  dark?: boolean;
}) {
  return <span className={dark ? 'text-teal-light' : 'text-teal'} data-id="element-161" data-mp="2bzxesvne19x7">{children}</span>;
}